import { memo, type FunctionComponent, type ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// Material UI imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// Media and SCSS imports
import { button, plain } from './AppBarBrand.module.scss';

type AppBarBrandProps = {
  readonly link?: string;
  readonly logo: ReactNode;
};

const AppBarBrand: FunctionComponent<AppBarBrandProps> = ({
  link,
  logo
}) => link ? (
  <Button
      color="primary"
      variant="text"
      component={RouterLink}
      to={link}
      className={button}
  >
    {logo}
  </Button>
) : (
  <Box className={plain}>
    {logo}
  </Box>
);

export default memo(AppBarBrand);
